function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.9933 32H29.3333C29.3333 27.8613 29.492 27.2667 26.9853 26.6853C23.1493 25.8 19.5267 24.964 18.2067 22.0747C17.7253 21.02 17.4053 19.2813 18.62 16.9893C21.3427 11.8467 22.0253 7.436 20.4907 4.888C18.7027 1.916 13.2733 1.9 11.4693 4.93333C9.93067 7.516 10.6227 11.9027 13.368 16.9667C14.608 19.2493 14.2973 20.9933 13.8187 22.0533C12.5093 24.9573 8.91867 25.7853 5.11867 26.6613C2.5 27.2667 2.66667 27.8213 2.66667 32H0.00666667L0 30.3453C0 26.9853 0.265333 25.0453 4.23733 24.128C8.724 23.092 13.1547 22.164 11.024 18.2373C4.71333 6.59867 9.224 0 16 0C22.644 0 27.268 6.35467 20.976 18.2373C18.908 22.1413 23.176 23.0693 27.7627 24.128C31.7347 25.0453 32 26.9853 32 30.3453L31.9933 32ZM14.0227 24L15.236 26.6667H16.788L18.0147 24H14.0227ZM18.016 32L17.0773 28H14.924L13.9853 32H18.016V32Z"
});

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8db44a65.svg";
export { ForwardRef as ReactComponent };